import { AbrangenciaNivelEnum } from '../generated/backend-enums.js';
export { AbrangenciaNivelEnum };
export const AbrangenciaMap = {
    [AbrangenciaNivelEnum.ALTA]: 'Alta',
    [AbrangenciaNivelEnum.MEDIA]: 'Média',
    [AbrangenciaNivelEnum.BAIXA]: 'Baixa',
};
